// import PropTypes from "prop-types";
// import "./style.css";

// function SmartTableCard({
//   title,
//   headerLeft = [],
//   headerRight = [],
//   columns = [],
//   rows = [],
//   children, // ⭐ IMPORTANT
// }) {
//   return (
//     <>
//       <div className="stc-card">
//         {/* 🔹 TOP HEADER */}
//         <div className="stc-header">
//           <div className="stc-header-left">
//             {title && <h2 className="stc-title">{title}</h2>}
//             {headerLeft.map((item, i) => (
//               <div key={i} className="stc-item">
//                 {item}
//               </div>
//             ))}
//           </div>

//           <div className="stc-header-right">
//             {headerRight.map((item, i) => (
//               <div key={i} className="stc-item">
//                 {item}
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* 🔹 TABLE */}
//         <div className="stc-table-wrapper">
//           <table className="stc-table">
//             <thead>
//               <tr>
//                 {columns.map((col, i) => (
//                   <th key={i} style={{ textAlign: col.align || "left", width: col.width }}>
//                     {col.label}
//                   </th>
//                 ))}
//               </tr>
//             </thead>

//             <tbody>
//               {rows.map((row, rIndex) => (
//                 <tr key={row.id || rIndex}>
//                   {columns.map((col, cIndex) => (
//                     <td key={cIndex} style={{ textAlign: col.align || "left" }}>
//                       {col.render ? col.render(row) : row[col.key]}
//                     </td>
//                   ))}
//                 </tr>
//               ))}

//               {rows.length === 0 && (
//                 <tr>
//                   <td
//                     colSpan={columns.length}
//                     style={{
//                       textAlign: "center",
//                       padding: "20px",
//                       fontSize: "16px",
//                     }}
//                   >
//                     No data available
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* 🔥 THIS FIXES YOUR POPUPS */}
//       {children}
//     </>
//   );
// }

// export default SmartTableCard;

// SmartTableCard.propTypes = {
//   title: PropTypes.string,
//   headerLeft: PropTypes.arrayOf(PropTypes.node),
//   headerRight: PropTypes.arrayOf(PropTypes.node),
//   columns: PropTypes.arrayOf(PropTypes.object),
//   rows: PropTypes.arrayOf(PropTypes.object),
//   children: PropTypes.node, // ⭐ allow popups/modals/etc
// };

// Updated View Of Table

// import PropTypes from "prop-types";
// import "./style.css";

// function SmartTableCard({
//   title,
//   headerLeft = [],
//   headerRight = [],
//   columns = [],
//   rows = [],
//   children,
// }) {
//   return (
//     <>
//       <div className="stc-card">
//         {/* 🔹 HEADER */}
//         <div className="stc-header">
//           <div className="stc-header-left">
//             {title && <h2 className="stc-title">{title}</h2>}
//             {headerLeft.map((item, i) => (
//               <div key={i}>{item}</div>
//             ))}
//           </div>

//           <div className="stc-header-right">
//             {headerRight.map((item, i) => (
//               <div key={i}>{item}</div>
//             ))}
//           </div>
//         </div>

//         {/* 🔹 TABLE */}
//         <div className="stc-table-container">
//           <table className="stc-table">
//             <thead>
//               <tr>
//                 {columns.map((col, i) => (
//                   <th
//                     key={i}
//                     style={{
//                       textAlign: col.align || "left",
//                       width: col.width,
//                     }}
//                   >
//                     {col.label}
//                   </th>
//                 ))}
//               </tr>
//             </thead>

//             <tbody>
//               {rows.map((row, rIndex) => (
//                 <tr key={row.id || rIndex}>
//                   {columns.map((col, cIndex) => (
//                     <td key={cIndex} style={{ textAlign: col.align || "left" }}>
//                       {col.render ? col.render(row) : row[col.key]}
//                     </td>
//                   ))}
//                 </tr>
//               ))}

//               {rows.length === 0 && (
//                 <tr>
//                   <td colSpan={columns.length} className="stc-empty">
//                     No data available
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {children}
//     </>
//   );
// }

// export default SmartTableCard;

// SmartTableCard.propTypes = {
//   title: PropTypes.string,
//   headerLeft: PropTypes.arrayOf(PropTypes.node),
//   headerRight: PropTypes.arrayOf(PropTypes.node),
//   columns: PropTypes.arrayOf(PropTypes.object),
//   rows: PropTypes.arrayOf(PropTypes.object),
//   children: PropTypes.node,
// };

import PropTypes from "prop-types";
import "./style.css";

function SmartTableCard({
  title,
  headerLeft = [],
  headerRight = [],
  columns = [],
  rows = [],
  children,
}) {
  return (
    <>
      <div className="stc-card">
        {/* 🔹 HEADER */}
        <div className="stc-header">
          <div className="stc-header-left">
            {title && <h2 className="stc-title">{title}</h2>}
            {headerLeft.map((item, i) => (
              <div key={i}>{item}</div>
            ))}
          </div>

          <div className="stc-header-right">
            {headerRight.map((item, i) => (
              <div key={i}>{item}</div>
            ))}
          </div>
        </div>

        {/* 🔹 TABLE */}
        <div className="stc-table-container">
          <table className="stc-table">
            <thead>
              <tr>
                {columns.map((col, i) => (
                  <th
                    key={i}
                    style={{
                      textAlign: col.align || "left",
                      width: col.width,
                    }}
                  >
                    {col.label}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {rows.map((row, rIndex) => (
                <tr key={row.id || rIndex}>
                  {columns.map((col, cIndex) => (
                    <td key={cIndex} style={{ textAlign: col.align || "left" }}>
                      {col.render ? col.render(row) : row[col.key]}
                    </td>
                  ))}
                </tr>
              ))}

              {rows.length === 0 && (
                <tr>
                  <td colSpan={columns.length} className="stc-empty">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {children}
    </>
  );
}

export default SmartTableCard;

SmartTableCard.propTypes = {
  title: PropTypes.string,
  headerLeft: PropTypes.arrayOf(PropTypes.node),
  headerRight: PropTypes.arrayOf(PropTypes.node),
  columns: PropTypes.arrayOf(PropTypes.object),
  rows: PropTypes.arrayOf(PropTypes.object),
  children: PropTypes.node,
};